<template>
  <div
    v-if="showMoreBtn"
    :class="[
      'l-flex',
      'l-flex--column',
      'l-flex--align-center',
      'u-margin-bottom-large',
    ]"
  >
    <p class="t-paragraph-large u-margin-bottom-small">
      Showing {{ visibleProducts }} of {{ totalProducts }} Products
    </p>
    <btn
      :text="buttonText"
      @click="loadMoreProducts"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import abTesting from "@mixins/abTesting";
import Btn from "../button/Btn.vue";

export default {
  components: {
    Btn,
  },
  mixins: [abTesting],
  props: {
    buttonText: {
      type: String,
      default: "Load More Products",
    },
    visibleProducts: {
      type: [String, Number],
      default: 0,
    },
    totalProducts: {
      type: [String, Number],
      default: 0,
    },
  },
  computed: {
    ...mapState("vwo", ["loadMore"]),
    showMoreBtn() {
      // const loadMore = this.loadMore;
      // const abTesting = this.abTesting;
      const visibleProducts = this.visibleProducts;
      const totalProducts = this.totalProducts;
      let result = false;
      if (
        // abTesting &&
        // loadMore &&
        // loadMore.variant1 &&
        visibleProducts < totalProducts
      ) {
        result = true;
      }
      return result;
    },
  },
  methods: {
    loadMoreProducts() {
      this.$emit('loadMoreProducts');
    },
  },
};
</script>

<style lang="scss" scoped></style>
